import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { Roles } from '../enums/roles.enum';

@Injectable({
  providedIn: 'root'
})
export class RoleService {
  constructor(private authService: AuthService) {}

  getCurrentRole(): Roles {
    const userInfo = this.authService.getUserInfo();
    const appRole = userInfo?.appRole || userInfo?.role;
    if (appRole === Roles.SME) {
      return Roles.SME;
    }
    return Roles.Standard;
  }

  isSME(): boolean {
    // Role gating is off until DPE tokens carry Voyager roles.
    return true;
  }

  canViewCollections(): boolean {
    return this.isSME();
  }

  canViewFeedback(): boolean {
    return this.isSME();
  }

  canViewMailbox(): boolean {
    return this.isSME();
  }

  canViewVisualizations(): boolean {
    return this.isSME();
  }

  canViewInferences(): boolean {
    return this.isSME();
  }

  setTestRole(role: Roles): void {
    const userInfo = this.authService.getUserInfo();
    if (userInfo) {
      userInfo.appRole = role.toString();
      this.authService.setUserInfo(userInfo);
    }
  }
}
